import React, {useEffect, useState} from 'react'
import Modal from '../../../../../../libs/_fri/components/CustomModal/CustomModal'
import {useUpdateBatchMutation} from '../../../../../../redux/api/services/batch'

import 'flatpickr/dist/flatpickr.css'
import Flatpickr from 'react-flatpickr'
import {useFormik} from 'formik'
import {useListView} from '../../core/ListViewProvider'
import CustomDateInput from '../../../../../../helpers/elements/inputs/CustomDateInput'
import {parseDateToISOString, roundedTime} from '../../../../../../helpers/utilities'
import * as Yup from 'yup'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

const validationSchema = Yup.object().shape({
  title: Yup.string().required('El título de pago es requerido'),
  reference: Yup.string().required('La referencia es requerida'),
})

interface IEditBatch {
  title: string
  reference: string
  dateTime: Date
}

export const BatchEditModal = () => {
  const [editBatch, {isSuccess, isError, error, reset}] = useUpdateBatchMutation()

  const {setBatchForUpdate, batchForUpdate} = useListView()
  const [dateTime, setDateTime] = useState<Date>(new Date(batchForUpdate?.scheduledDate || ''))
  const infoState = useSelector((state: RootState) => state.info)

  const initialValues: IEditBatch = {
    title: batchForUpdate?.title || '',
    reference: batchForUpdate?.reference || '',
    dateTime: new Date(batchForUpdate?.scheduledDate || ''),
  }

  useEffect(() => {
    if (!isSuccess) return

    setBatchForUpdate(undefined)
  }, [isSuccess])

  const handleSubmit = (values: IEditBatch) => {
    if (!batchForUpdate) return

    const requestData = {
      info: infoState,
      requestContent: {
        batchId: batchForUpdate.id,
        title: values.title,
        reference: values.reference,
        scheduleTime: parseDateToISOString(values.dateTime),
        clientTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    }
    editBatch(requestData)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <Modal
      handleClose={() => {
        setBatchForUpdate(undefined)
      }}
      handleConfirm={formik.handleSubmit}
      variant='primary'
      size='lg'
    >
      <div className='d-flex flex-column px-21'>
        <span className='fs-2x text-primary-dark fw-semibold text-center mb-15 '>
          Editar pago programado
        </span>
        <CustomErrorAlert show={isError} error={error} close={reset} />

        <div className='row mb-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Título del pago</label>
            <input
              name='title'
              type='text'
              placeholder='Ej: Pago área comercial'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.title}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>{formik.touched.title && formik.errors.title}</div>
          </div>
        </div>
        <div className='row mb-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2 required'>Referencia</label>
            <input
              name='reference'
              type='text'
              placeholder='Ej: Bono anual'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.reference}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>
              {formik.touched.reference && formik.errors.reference}
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='d-flex flex-column'>
              <label className='form-label mb-3 text-gray fs-2'>Fecha a pagar</label>
              <Flatpickr
                options={{
                  enableTime: true,
                  dateFormat: 'd/M/Y - H:i',
                  disableMobile: true,
                  minuteIncrement: 30,
                }}
                render={({defaultValue, value, ...props}, ref) => {
                  return <CustomDateInput ref={ref} />
                }}
                onChange={([date]) => {
                  setDateTime(roundedTime(date))
                  formik.setFieldValue('dateTime', date)
                }}
                value={dateTime}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
